import { useState, useEffect } from 'react'
import { marketingApi } from '../api/marketing'
import Modal from '../components/Modal'
import Boton from '../components/Boton'

const EMPTY = { nombre: '', tipo: 'dinamica', descripcion: '', definicion: {} }

export default function MktListasPage() {
  const [listas, setListas] = useState([])
  const [modal, setModal] = useState(null) // 'new' | lista
  const [form, setForm] = useState(EMPTY)
  const [preview, setPreview] = useState(null)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState('')

  const cargar = () => marketingApi.listas().then(r => setListas(r.data))
  useEffect(() => { cargar() }, [])

  const openNew = () => { setForm(EMPTY); setErr(''); setPreview(null); setModal('new') }
  const openEdit = (l) => {
    setForm({ nombre: l.nombre, tipo: l.tipo, descripcion: l.descripcion || '', definicion: l.definicion || {} })
    setErr(''); setPreview(null); setModal(l)
  }

  const setDef = (k, v) => setForm(f => ({
    ...f,
    definicion: { ...f.definicion, [k]: v === '' ? undefined : v },
  }))

  const guardar = async (e) => {
    e.preventDefault(); setSaving(true); setErr('')
    const payload = { ...form, definicion: form.tipo === 'dinamica' ? form.definicion : null }
    try {
      if (modal === 'new') await marketingApi.crearLista(payload)
      else await marketingApi.actualizarLista(modal.id, payload)
      setModal(null); cargar()
    } catch (error) { setErr(error.response?.data?.message || 'Error al guardar') }
    finally { setSaving(false) }
  }

  const previsualizar = async () => {
    if (modal === 'new') { setErr('Guardá la lista primero para previsualizar.'); return }
    const r = await marketingApi.previewLista(modal.id)
    setPreview(r.data)
  }

  const eliminar = async (l) => {
    if (!window.confirm(`¿Eliminar la lista "${l.nombre}"?`)) return
    await marketingApi.eliminarLista(l.id); cargar()
  }

  const def = form.definicion || {}

  return (
    <div>
      <div style={st.head}>
        <h2 style={st.title}>Listas y segmentos</h2>
        <Boton variante="primary" onClick={openNew}>+ Nueva</Boton>
      </div>

      <div style={st.cards}>
        {listas.map(l => (
          <div key={l.id} style={st.card}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={st.nombre}>{l.tipo === 'dinamica' ? '⚡' : '📋'} {l.nombre}</p>
              <p style={st.desc}>{l.descripcion || (l.tipo === 'dinamica' ? 'Segmento dinámico' : 'Lista estática')}</p>
              <p style={st.aptos}><strong>{l.aptos_envio}</strong> contactos aptos para envío</p>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <Boton variante="secondary" sm onClick={() => openEdit(l)}>Editar</Boton>
              <Boton variante="destructive" sm onClick={() => eliminar(l)}>Eliminar</Boton>
            </div>
          </div>
        ))}
        {listas.length === 0 && <p style={{ color: '#94a3b8' }}>Sin listas. Creá un segmento dinámico (ej: "compró en 90 días") o una lista estática.</p>}
      </div>

      {modal && (
        <Modal title={modal === 'new' ? 'Nueva lista / segmento' : `Editar — ${modal.nombre}`} onClose={() => setModal(null)}>
          <form onSubmit={guardar} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={st.lbl}>Nombre *</label>
              <input style={st.inp} value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} required />
            </div>
            {modal === 'new' && (
              <div>
                <label style={st.lbl}>Tipo</label>
                <select style={st.inp} value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))}>
                  <option value="dinamica">⚡ Segmento dinámico (por reglas, se recalcula solo)</option>
                  <option value="estatica">📋 Lista estática (contactos elegidos a mano)</option>
                </select>
              </div>
            )}
            <div>
              <label style={st.lbl}>Descripción</label>
              <input style={st.inp} value={form.descripcion} onChange={e => setForm(f => ({ ...f, descripcion: e.target.value }))} />
            </div>

            {form.tipo === 'dinamica' && (
              <div style={st.reglas}>
                <p style={st.reglasTitulo}>Reglas (se combinan con Y)</p>
                <div style={st.reglasGrid}>
                  <div>
                    <label style={st.lbl}>Compró en los últimos (días)</label>
                    <input style={st.inp} type="number" min="1" value={def.dias_ultima_compra || ''}
                      onChange={e => setDef('dias_ultima_compra', e.target.value ? Number(e.target.value) : '')} placeholder="ej: 90" />
                  </div>
                  <div>
                    <label style={st.lbl}>Compró del rubro</label>
                    <input style={st.inp} value={def.rubro || ''} onChange={e => setDef('rubro', e.target.value)} placeholder="ej: VINOS" />
                  </div>
                  <div>
                    <label style={st.lbl}>Provincia</label>
                    <input style={st.inp} value={def.provincia || ''} onChange={e => setDef('provincia', e.target.value)} placeholder="ej: CABA" />
                  </div>
                  <div>
                    <label style={st.lbl}>Origen del contacto</label>
                    <select style={st.inp} value={def.origen || ''} onChange={e => setDef('origen', e.target.value)}>
                      <option value="">Cualquiera</option>
                      <option value="cliente">Cliente LGR</option>
                      <option value="magento">Tienda online</option>
                      <option value="mailchimp_import">Import Mailchimp</option>
                    </select>
                  </div>
                </div>
                <p style={st.nota}>Sin reglas = todos los suscriptos. La supresión global se aplica siempre.</p>
              </div>
            )}

            {preview && (
              <div style={st.previewBox}>
                <strong>{preview.total}</strong> contactos matchean.
                {preview.muestra?.length > 0 && (
                  <span style={{ color: '#64748b' }}> Muestra: {preview.muestra.slice(0, 5).map(m => m.email).join(', ')}…</span>
                )}
              </div>
            )}

            {err && <p style={{ color: '#dc2626', fontSize: '0.875rem', margin: 0 }}>{err}</p>}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              {modal !== 'new' && form.tipo === 'dinamica'
                ? <Boton variante="secondary" sm type="button" onClick={previsualizar}>👁 Previsualizar</Boton> : <span />}
              <div style={{ display: 'flex', gap: 8 }}>
                <Boton variante="ghost" type="button" onClick={() => setModal(null)}>Cancelar</Boton>
                <Boton variante="primary" type="submit" disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</Boton>
              </div>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const st = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  title: { margin: 0, fontSize: '1.4rem', color: '#0f172a' },
  cards: { display: 'flex', flexDirection: 'column', gap: 10 },
  card: { display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 16px' },
  nombre: { margin: 0, fontWeight: 700, color: '#0f172a' },
  desc: { margin: '2px 0 0', fontSize: '0.82rem', color: '#94a3b8' },
  aptos: { margin: '6px 0 0', fontSize: '0.85rem', color: '#1e40af' },
  lbl: { display: 'block', fontWeight: 600, fontSize: '0.82rem', color: '#374151', marginBottom: 4 },
  inp: { width: '100%', padding: '0.5rem 0.7rem', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box', background: '#fff' },
  reglas: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: 12 },
  reglasTitulo: { margin: '0 0 10px', fontSize: '0.78rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase' },
  reglasGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  nota: { margin: '10px 0 0', fontSize: '0.75rem', color: '#94a3b8' },
  previewBox: { background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 12px', fontSize: '0.85rem' },
}
